import { useId, useState } from 'react';
import type { ReactNode } from 'react';

import { FaIcon } from '../icons/FaIcon';

export type DataPanelProps = {
  header: string;
  headerActions?: ReactNode;
  cssClass?: string;
  children?: ReactNode;
  beforeItemsTemplate?: ReactNode;
  defaultExpanded?: boolean;
  testID?: string;
};

export function DataPanel({
  header,
  headerActions,
  cssClass,
  children,
  beforeItemsTemplate,
  defaultExpanded = true,
  testID,
}: DataPanelProps) {
  const contentId = useId();
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`data-panel ${cssClass ?? ''}`} data-testid={testID}>
      <div className="data-panel__header position-relative d-flex flex-row align-items-center gap-1 px-2 py-1 bg-light rounded-1">
        <h2 className="h5 mb-0 flex-grow-1">
          <button
            type="button"
            className="data-panel__toggle stretched-link"
            aria-expanded={isExpanded}
            aria-controls={contentId}
            onClick={() => setIsExpanded((expanded) => !expanded)}
            data-testid={testID === undefined ? undefined : `${testID}-toggle`}
          >
            {header}
          </button>
        </h2>

        {headerActions != null && <div className="data-panel__header-actions">{headerActions}</div>}

        <FaIcon icon={isExpanded ? 'fa-regular fa-chevron-down' : 'fa-regular fa-chevron-up'} />
      </div>

      {beforeItemsTemplate != null && (
        <div className="data-panel__before-items">{beforeItemsTemplate}</div>
      )}

      <div
        id={contentId}
        className="data-panel__content d-flex flex-column"
        style={{ rowGap: '1px' }}
        hidden={!isExpanded}
        data-testid={testID === undefined ? undefined : `${testID}-content`}
      >
        {isExpanded && children}
      </div>
    </div>
  );
}
